// @flow
import * as React from "react"
import {Link} from "react-router-dom"

export const PlainLink = (props: Object) => (
  <Link
    {...props}
    style={{color: "inherit", textDecoration: "none", ...props.style}}
  />
)



// WEBPACK FOOTER //
// ./src/common/PlainLink.js